import { Endpoint } from '@business/api/endpoint';
import { BlockTemplateResponse, CopyTemplateRequest, FetchTemplateResponse, IndexTemplateStatus, SettingTemplateType, TemplateFolderId, TemplateId, TemplateLibraryItemResponse } from '@business/entities/template';

export function getItem(id: string, type: string, isPublic = true) {
  const prefix = isPublic ? 'public/' : '';
  if (type == 'template') {
    return Endpoint.get<TemplateLibraryItemResponse>(`@gc/${prefix}template/item/${id}`);
  } else {
    return Endpoint.get<TemplateLibraryItemResponse>(`@gc/template-admin/item/${id}`);
  }
}

export function fetchTemplates(full = false, status = 'active', folderId?: TemplateFolderId, type?: SettingTemplateType) {
  return Endpoint.get<FetchTemplateResponse[]>(`@gc/template`, { params: { full, status, folderId: folderId || '0', ...(type ? { type } : {}) } });
}

export function fetchTemplate(id: TemplateId) {
  return Endpoint.get<FetchTemplateResponse>(`@gc/template/item/${id}`);
}

export function createTemplate(data: Partial<FetchTemplateResponse> & { libraryId?: string }) {
  return Endpoint.post<FetchTemplateResponse>(`@gc/template`, { data });
}

export function updateTemplate(id: TemplateId, data: Partial<FetchTemplateResponse>) {
  return Endpoint.patch<FetchTemplateResponse>(`@gc/template/${id}`, { data });
}

export function deleteTemplate(id: TemplateId) {
  return Endpoint.delete<FetchTemplateResponse>(`@gc/template/${id}`);
}

export function updateFormData(id: string, data: string) {
  return Endpoint.post<FetchTemplateResponse>(`@gc/template/update-form-data/${id}`, { data: { data } });
}

export function duplicateTemplate(id: TemplateId, name: string) {
  return Endpoint.post<FetchTemplateResponse>(`@gc/template/duplicate/${id}`, { data: { name } });
}

export function moveTemplate(id: TemplateId, folderId: TemplateFolderId) {
  return Endpoint.post<FetchTemplateResponse>(`@gc/template/move/${id}`, { data: { folderId } });
}

export function changeStatus(id: TemplateId, status: IndexTemplateStatus) {
  return Endpoint.post<FetchTemplateResponse>(`@gc/template/status/${id}`, { data: { status } });
}

export function copyBlockTemplate(data: CopyTemplateRequest) {
  return Endpoint.post<void>(`@gc/template/copy-template`, { data });
}

export function fetchBlockTemplates(type: string) {
  return Endpoint.get<BlockTemplateResponse[]>(`@gc/template/block-templates`, { params: { type } });
}

export function deleteBlockTemplate(id: string) {
  return Endpoint.delete<void>(`@gc/template/block-template/${id}`);
}
